import { createStore } from 'zustand/vanilla';
export const DEFAULT_TABLE_LIST_CONFIG = {
    columnDefs: [],
    hPadding: 'm'
};
export const createTableListStore = (initialState)=>createStore(()=>initialState);
